const FAQsIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M12 3a9 9 0 1 0 9 9'
      stroke='currentColor'
      strokeWidth='1.6'
      fill='none'
    />
    <circle cx='12' cy='17' r='1.3' fill='currentColor' />
    <path d='M12 7v6' stroke='currentColor' strokeWidth='1.6' />
  </svg>
);

export default FAQsIcon;
